<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="paymentDetail && payment" class="container justify-content-center pb-5">
  <h1 class="text-center lifedi-color m-3">
    รายการทางการเงิน
  </h1>

  <div class="row">
    <h4 class="col-lg-6 col-md-12 col-sm-12 text-left mt-3 lifedi-color">รหัสรายการ: {{ payment[0].PAYMENT_ID }}
    </h4>
    <div class="col-lg-6 col-md-12 col-sm-12 text-right mt-3">
      <p style="font-size: large;">หมวดหมู่:
        <span *ngIf="payment[0].TYPE === 'course'">คอร์สเรียน</span>
        <span *ngIf="payment[0].TYPE === 'consult'">กิจกรรม(consult)</span>
        <span *ngIf="payment[0].TYPE === 'workshop'">กิจกรรม(workshop)</span>
      </p>
      <p style="font-size: large;">
        ผู้ทำรายการ: {{ payment[0].USERNAME }}
      </p>
    </div>
  </div>

  <mat-card class="my-3 row">

    <!-- <div class="col-12"> -->
    <div class="my-3 mb-3 col-12">
      <div class="row d-flex justify-content-center">
        <div class="col-12">
          <div class="row m-3">
            <h5 class="col-lg-6 col-md-6 col-sm-12 text-center" style="margin-top: 30px;">{{ payment[0].PAYMENT_NAME }}
            </h5>
            <h5 class="col-lg-6 col-md-6 col-sm-12 text-center" style="margin-top: 30px;">
              {{ payment[0].PRICE | number }} บาท</h5>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <img [src]="paymentDetail[0].TRANFER_PIC" class="img-fluid" style="width: 550px;" alt="">
      </div>
      <div class="row">
        <div class="col-12">
          <h4 class="text-center m-3">จำนวนเงินที่แจ้งโอน {{ paymentDetail[0].TRANFER_PRICE | number }} บาท</h4>
        </div>
        <div class="col-12">
          <h4 class="text-center m-3" *ngIf="paymentDetail[0].PAYMENT_TYPE === '2c2p'">
            ชำระผ่านทาง CREDIT CARD
          </h4>
          <h4 class="text-center m-3" *ngIf="paymentDetail[0].PAYMENT_TYPE === 'transfer'">
            ชำระผ่านทางการโอน
          </h4>

          <!-- <h4 class="text-center m-3"> {{ paymentDetail[0].TRANFER_DATE | date }}
            <span *ngIf="paymentDetail[0].TRANFER_HR.length > 1">{{ paymentDetail[0].TRANFER_HR }}:</span>
            <span *ngIf="paymentDetail[0].TRANFER_HR.length === 1">0{{ paymentDetail[0].TRANFER_HR }}:</span>
            <span *ngIf="paymentDetail[0].TRANFER_MIN.length > 1">{{ paymentDetail[0].TRANFER_MIN }} น.</span>
            <span *ngIf="paymentDetail[0].TRANFER_MIN.length === 1">0{{ paymentDetail[0].TRANFER_MIN }} น.</span>
          </h4> -->
        </div>
      </div>
      <form [formGroup]="transferDateForm">
        <div class="d-flex justify-content-center my-3">
          <div class="form-group mx-2">
            <label for="date" class="form-label">วันที่</label>
            <input type="text" id="date" class="form-control date" formControlName="TRANFER_DATE" bsDatepicker
              date-format="DD-MM-YYYY" autocomplete="off"
              [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false, language:'th-th' }" [maxDate]="today">
          </div>
          <div class="form-group mx-2">
            <label for="date" class="form-label">ชั่วโมง</label>
            <input type="number" class="form-control time" min="0" max="23" formControlName="TRANFER_HR"
              pattern="[0-9]*" (keyup)="time($event, 'hr')" placeholder="HH">
          </div>
          <div class="form-group mx-2">
            <label for="date" class="form-label">นาที</label>
            <input type="number" class="form-control time" min="0" max="59" formControlName="TRANFER_MIN"
              pattern="[0-9]*" (keyup)="time($event, 'min')" placeholder="MM">
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-center my-3">
        <div *ngIf="!isEditDate" (click)="editDate()" class="btn btn-success mx-2">แก้ไข</div>
        <div *ngIf="isEditDate" (click)="cancelEdit()" class="btn btn-outline-secondary mx-2">ย้อนกลับ</div>
        <div *ngIf="isEditDate && transferDateForm.valid" (click)="confirmEdit(transferDateForm.value)"
          class="btn btn-primary mx-2">ยืนยัน</div>
        <div *ngIf="isEditDate && !transferDateForm.valid" class="btn btn-primary mx-2 disabled">ยืนยัน</div>
      </div>
    </div>
    <!-- </div> -->

    <div *ngIf="paymentDetail[0].EVIDENCE_DATA.length > 0" class="my-5 mb-3 col-12">
      <hr width="100%">
      <h3 class="my-3 text-center">หลักฐานเพื่อรับส่วนลด</h3>

      <div class="row justify-content-center my-3">
        <div *ngFor="let i of evidenceImage" [ngClass]="evidenceImage.length === 2 ? 'justify-content-center' : ''"
          class="col-4 d-flex align-items-stretc">
          <mat-card *ngIf="i.TYPE_FILE === 'image'" class="evidence m-3">
            <img nz-image class="rounded img-fluid" [nzSrc]="i.EVIDEN_FILE" alt="">
          </mat-card>
        </div>
      </div>

      <div class="row justify-content-center my-3">
        <div *ngFor="let i of evidenceFile" [ngClass]="evidenceFile.length === 2 ? 'justify-content-center' : ''"
          class="col-4">
          <mat-card *ngIf="i.TYPE_FILE === 'file'" (click)="download(i.EVIDEN_FILE)" class="evidence-file m-3">
            <div class="d-flex item">
              <!-- <img *ngIf="i.TYPE_FILE === 'image'" [src]="i.EVIDEN_FILE" alt=""> -->
              <img src="assets/google-docs.png" alt="">
              <span class="file-name cut-text">
                {{ i.EVIDEN_ORGINAL_NAME }}
              </span>
            </div>
          </mat-card>
        </div>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-center">
      <form [formGroup]="remarkPriceForm">
        <div class="form-group row">
          <label for="amount" class="col-form-label col-12 text-center">
            ยอดเงินที่ชำระทั้งหมด
          </label>
          <div class="col-12">
            <input type="number" class="form-control" id="amount" formControlName="price" autocomplete="off">
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 d-flex justify-content-center">

      <button mat-button class="bg-success m-3" *ngIf="remarkPriceForm.valid" (click)="confirm(remarkPriceForm.value)"
        style="color: #fff;">
        ถูกต้อง
      </button>
      <button mat-button class="bg-danger m-3" *ngIf="remarkPriceForm.valid" (click)="reject(remarkPriceForm.value)"
        style="color: #fff;">
        ไม่ถูกต้อง
      </button>
      <button mat-button class="bg-secondary m-3" *ngIf="!remarkPriceForm.valid" style="color: #fff;" disabled>
        ถูกต้อง
      </button>
      <button mat-button class="bg-secondary m-3" *ngIf="!remarkPriceForm.valid" style="color: #fff;" disabled>
        ไม่ถูกต้อง
      </button>
    </div>

  </mat-card>

  <div *ngIf="isPrint">
    <lifedi-payment-receipt [receiptDetail]="receiptDetail" [accountId]="accountId" [isSendMail]="true"
      (sendEmail)="sendMail($event)"></lifedi-payment-receipt>
  </div>

  <div *ngIf="isLoading">
    <div
      style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
  </div>

</div>